export default "__VITE_ASSET__BjB_ZMD6__"